import styled from 'styled-components';

const HeadingWrapper = styled.h1`
  display: flex;
  align-items: center;
  height: 50px;
  padding: 0 4%;
  background-color: #ffffff;
  color: #000000;
  user-select: none;
  font-family: 'Avenir Black', 'Arial Black', sans-serif;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: 1px;
  text-transform: uppercase;
  ${({ isDesktop }) =>
    isDesktop ? 'justify-content: center; line-height: 40px; font-size: 30px;' : 'border-bottom: solid 2px #000000;'}
`;

export { HeadingWrapper };
